const analyticsTrackEvent = Object.freeze({
  CO_BROWSE_STATE_CHANGE: 'CO_BROWSE_STATE_CHANGE'
})

export { analyticsTrackEvent }
